// Sync learned XDF/ADX passwords with the logged-in user's account so they follow the
// user across browsers/PCs. Best-effort: silently no-ops when logged out or offline.
import { api } from "./api";
import { getLearnedPasswords, rememberXdfPassword } from "./xdfCrypto";

// Pull the account's saved passwords and merge them into the local (localStorage) store.
export async function pullLearnedFromServer() {
  try {
    const { data } = await api.get("/xdf/passwords");
    const list = Array.isArray(data?.passwords) ? data.passwords : [];
    if (list.length) rememberXdfPassword(...list);
  } catch (_) { /* logged out / offline — keep local only */ }
  return getLearnedPasswords();
}

// Push the full local learned list to the account, then merge the server's echo back.
export async function pushLearnedToServer() {
  try {
    const list = getLearnedPasswords();
    const { data } = await api.post("/xdf/passwords", { passwords: list });
    const merged = Array.isArray(data?.passwords) ? data.passwords : [];
    if (merged.length) rememberXdfPassword(...merged);
  } catch (_) { /* logged out / offline — keep local only */ }
  return getLearnedPasswords();
}
